import { render, staticRenderFns } from "./icon.component.vue?vue&type=template&id=1ce30880&lang=pug"
import script from "./icon.component.vue?vue&type=script&lang=ts"
export * from "./icon.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports